import styled from "styled-components";
import { motion } from "framer-motion";
import { typeStyle, units } from "@m/alchemy-theme";
export const AppMenuListItemExpandLabel = styled.span `
  ${typeStyle("bodyS")};
`;
export const AppMenuListItemExpandableItemTrigger = styled.div `
  position: absolute;
  right: ${units(2)};
  top: ${units(1.5)};
`;
export const AppMenuListItemExpanded = styled(motion.li) `
  overflow: hidden;

  ul li {
    padding-left: ${units(4)};
  }
`;
